/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadMeResponse
 */
export interface UploadMeResponse {
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    phone: string | null;
    /**
     * 
     */
    isTeam: boolean;
}

/**
 * Check if a given object implements the UploadMeResponse interface.
 */
export function instanceOfUploadMeResponse(value: object): value is UploadMeResponse {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if ((!('isTeam' in (value as Record<string, any>)) && !('is_team' in (value as Record<string, any>))) || ((value as Record<string, any>)['isTeam'] === undefined && (value as Record<string, any>)['is_team'] === undefined)) return false;
    return true;
}

export function UploadMeResponseFromJSON(json: any): UploadMeResponse {
    return UploadMeResponseFromJSONTyped(json, false);
}

export function UploadMeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadMeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'phone': json['phone'],
        'isTeam': json['is_team'],
    };
}

export function UploadMeResponseToJSON(json: any): UploadMeResponse {
    return UploadMeResponseToJSONTyped(json, false);
}

export function UploadMeResponseToJSONTyped(value?: UploadMeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'phone': value['phone'],
        'is_team': value['isTeam'],
    };
}

